import './StockOrderDetailSkeleton.scss';

const StockOrderDetailSkeleton = () => {
  return (
    <div className="stockOrderDetailSkeleton">
      <section className="headerDetail">
        <div className="leftSection">
          <div className="flex items-center justify-between w-full">
            <div className="tabsContainer">
              {[1, 2, 3].map(index => (
                <div key={index} className="skeletonTab animate-pulse" />
              ))}
            </div>
            <div className="skeletonCancelButton animate-pulse" />
          </div>
        </div>
      </section>

      <section className="tabContent">
        <div className="skeletonContent">
          {/* Skeleton para Tab1General */}
          <div className="skeletonGeneralInfo">
            <div className="skeletonCard animate-pulse">
              <div className="skeletonCardHeader" />
              <div className="skeletonCardBody">
                {[1, 2, 3].map(index => (
                  <div key={index} className="skeletonLine animate-pulse" />
                ))}
              </div>
            </div>
            <div className="skeletonCard animate-pulse">
              <div className="skeletonCardHeader" />
              <div className="skeletonCardBody">
                {[1, 2].map(index => (
                  <div key={index} className="skeletonLine animate-pulse" />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StockOrderDetailSkeleton;
